import React, { useState } from 'react';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Input from '@mui/material/Input';
import Grid from '@mui/material/Grid';

import StateSelector from './StateSelector';
import CrmButton from './CrmButton';

const useLocalInputStyles = makeStyles((theme) =>
  createStyles({
    input: {
      '&.MuiInput-underline:after': {
        borderBottomColor: theme.palette.secondary.main,
      },
    },
    inputFontSize: {
      fontSize: '0.95rem',
    },
  })
);

const LocalInput = ({ placeholder, value, onChange }) => {
  const classes = useLocalInputStyles();
  return (
    <Input
      className={classes.input}
      fullWidth={true}
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      inputProps={{ className: classes.inputFontSize }}
    />
  );
};

const usePanelStyles = makeStyles((theme) =>
  createStyles({
    addressEdit_state: {
      transform: 'scale(0.9, 0.8) translate(-14px, -18px)',
    },
    saveButton: {
      transform: 'scale(0.7) translate(-24px, -10px)',
    },
  })
);

function saveAddress(saveFunc, street, city, state, zip) {
  const address = { street, city, state, zip };
  saveFunc(address);
}

const FacePageUsAddressPanel = ({ address, validationFunc, saveFunc, changedExternally }) => {
  const classes = usePanelStyles();
  const [street, setStreet] = useState(address.street);
  const [city, setCity] = useState(address.city);
  const [state, setState] = useState(address.state);
  const [zip, setZip] = useState(address.zip);

  if (changedExternally) {
    if (street !== address.street) {
      setStreet(address.street);
    }
    if (city !== address.city) {
      setCity(address.city);
    }
    if (state !== address.state) {
      setState(address.state);
    }
    if (zip !== address.zip) {
      setZip(address.zip);
    }
    changedExternally = false;
  }

  const modified = address.street !== street || address.city !== city || address.state !== state || address.zip !== zip;

  const valid = validationFunc(street, city, state, zip);

  const stateWidth = modified ? 6 : 9;

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <LocalInput placeholder="Street" value={street} onChange={(newValue) => setStreet(newValue)} />
        </Grid>
        <Grid item xs={12}>
          <LocalInput placeholder="City" value={city} onChange={(newValue) => setCity(newValue)} />
        </Grid>
        <Grid item className={classes.addressEdit_state} xs={stateWidth}>
          <StateSelector value={state} onChange={(newValue) => setState(newValue)} />
        </Grid>
        <Grid item xs={3}>
          <LocalInput placeholder="Zip Code" value={zip} onChange={(newValue) => setZip(newValue)} />
        </Grid>
        {modified && (
          <Grid item className={classes.saveButton} xs={3}>
            <CrmButton filled disabled={!valid} onClick={() => saveAddress(saveFunc, street, city, state, zip)}>
              Save
            </CrmButton>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default FacePageUsAddressPanel;
